import React, {Component, Fragment} from 'react';
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import {Route, Routes} from 'react-router-dom'
import {withTranslation} from "react-i18next";

import JobDetailController from "../controllers/JobDetailController";
import JobRoleController from "../controllers/JobRoleController";
import JobQualificationsController from "../controllers/JobQualificationsController";
import JobThinkController from "../controllers/JobThinkController";
import JobRightController from "../controllers/JobRightController";


import {GelContentContainer, Loading, NotFound, StyleguideContext} from 'cw-styleguide-react';
import {route} from "../routes";



class JobLandingView extends Component {


  render() {

    return (

      <Fragment>
        <BreadcrumbsItem glyph='user' to={'/' + this.props.data.slug}>
          {this.props.data.name}
        </BreadcrumbsItem>

<Routes>
        <Route  index element={<JobDetailController job={this.props.data} {...this.props} />}/>

        <Route path={ route('role')}
               element={<JobRoleController job={this.props.data}  {...this.props} />}/>

        <Route path={route('right')}
               element={<JobRightController job={this.props.data}  {...this.props} />}/>

        <Route path={ route('qualifications')}
               element={ <JobQualificationsController job={this.props.data}  {...this.props} />}/>

        <Route path={route('think')}
               element={ <JobThinkController job={this.props.data}  {...this.props} />}/>
    <Route path="*" element={<NotFound/>} />
</Routes>
      </Fragment>
    )
  }
}

JobLandingView.contextType = StyleguideContext;
export default withTranslation(['common', 'styleguide'])(JobLandingView);